<template>
  <div>
    <div>
      <div v-if="loaded && adminTransactions.length === 0">
        <div class="alert alert-primary" role="alert">تراکنشی یافت نشد.</div>
      </div>
    </div>

    <div>
      <b-row class="mb-3">
        <b-col sm="12" lg="2" class="mb-2">
          <b-form-select
            v-model="searchType"
            :options="[
              { value: null, text: 'همه' },
              { value: 1, text: 'دستی' },
              { value: 2, text: 'پرداخت' },
              { value: 3, text: 'پخش' },
              { value: 4, text: 'فضای ابری' }
            ]"
          ></b-form-select>
        </b-col>
        <b-col sm="12" lg="3" class="mb-2">
          <date-picker
            type="date"
            v-model="fromDate"
            name="start"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="HH:mm jYYYY/jMM/jDD"
            color="#4554a0"
            label="تاریخ شروع"
            class="date-picker-style"
          />
        </b-col>
        <b-col sm="12" lg="3" class="mb-2">
          <date-picker
            type="date"
            v-model="toDate"
            name="start"
            format="YYYY-MM-DD HH:mm:ss"
            display-format="HH:mm jYYYY/jMM/jDD"
            color="#4554a0"
            label="تاریخ پایان"
            class="date-picker-style"
          />
        </b-col>
        <b-col align-v="center" align-h="between" sm="12" lg="3" class="mb-2">
          <button
            type="button"
            class="btn btn-primary p-2"
            title="جستجو"
            @click="updateTransactions"
            :disabled="!loaded"
          >
            <i class="fal fa-search pt-1" />
            جستجو
          </button>
          <button
            type="button"
            class="btn btn-outline-primary p-2 ml-2"
            title="دانلود"
            @click="exportTransactions"
            :disabled="exportloading"
          >
            <i class="fal fa-file-export pt-1" />
            دانلود
          </button>
        </b-col>
        <b-col
          align-v="center"
          align-h="between"
          sm="12"
          lg="1"
          class="d-flex justify-content-end align-items-center mb-1"
        >
          <div>
            <span class="badge bg-secondary text-white font-size-sm">
              تعداد تراکنش ها :
              <span dir="ltr" class="font-size-sm text-white">
                {{ numberFormat(adminTransactionsPagination.total) }}
              </span>
            </span>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      v-if="loaded && adminTransactions.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>کاربر</th>
                <th>بابت</th>
                <th>
                  مبلغ (ریال)
                  <span
                    @click="sortBy('value')"
                    v-html="sortIcon('value')"
                  ></span>
                </th>
                <th>توضیحات</th>
                <th>
                  تاریخ
                  <span
                    @click="sortBy('created_at')"
                    v-html="sortIcon('created_at')"
                  ></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="transaction in adminTransactions"
                :key="transaction.id"
              >
                <td>
                  <router-link
                    :to="{
                      name: 'admin-users-show',
                      params: { id: transaction.user_id }
                    }"
                  >
                    {{ gFullName(transaction.user) }}
                  </router-link>
                </td>

                <td>
                  <router-link
                    v-show="transaction.relation_type === 3"
                    class="text-primary"
                    :to="{
                      name: 'admin-receipts-lives-show',
                      params: { id: transaction.relation_id }
                    }"
                  >
                    {{ transactionRelationTypes[transaction.relation_type] }}
                  </router-link>
                  <router-link
                    v-show="transaction.relation_type === 4"
                    class="text-primary"
                    :to="{
                      name: 'admin-receipts-storage-show',
                      params: { id: transaction.relation_id }
                    }"
                  >
                    {{ transactionRelationTypes[transaction.relation_type] }}
                  </router-link>
                  <span
                    v-show="
                      transaction.relation_type !== 3 &&
                        transaction.relation_type !== 4
                    "
                  >
                    {{ transactionRelationTypes[transaction.relation_type] }}
                  </span>
                </td>
                <td
                  class="text-nowrap"
                  dir="ltr"
                  :class="{ 'text-danger': transaction.value < 0 }"
                >
                  {{ numberFormat(transaction.value) }}
                </td>
                <td class="text-nowrap">{{ transaction.description }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(transaction.created_at) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="overflow-auto mt-5"
      v-if="adminTransactionsPagination.lastPage > 1"
    >
      <b-pagination
        v-model="adminTransactionsPagination.currentPage"
        :total-rows="adminTransactionsPagination.total"
        :per-page="adminTransactionsPagination.perPage"
        aria-controls="my-table"
        @input="updateTransactions()"
      ></b-pagination>
    </div>
  </div>
</template>

<style>
.vpd-icon-btn {
  margin-bottom: 0;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_ADMIN_TRANSACTIONS,
  SET_ADMIN_TRANSACTIONS_PAGINATION_PAGE
} from "@/core/services/store/admin/transactions.module";
import { mapGetters } from "vuex";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { DOWNLOAD_ADMIN_TRANSACTIONS } from "../../../../core/services/store/admin/transactions.module";

export default {
  name: "admin-transactions",
  data() {
    return {
      loaded: false,
      exportloading: false,
      searchType: null,
      fromDate: null,
      toDate: null
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "تراکنش‌ها" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.updateTransactions();
  },
  computed: {
    ...mapGetters([
      "adminTransactions",
      "adminTransactionsPagination",
      "transactionRelationTypes"
    ])
  },
  methods: {
    sortIcon(field) {
      let col = this.$store.state.adminTransactions.sort.col;
      let dir = this.$store.state.adminTransactions.sort.dir;

      if (col !== field) {
        return '<i class="fal fa-sort cursor-pointer"></i>';
      }
      if (dir === "asc") {
        return '<i class="fal fa-sort-up cursor-pointer"></i>';
      }
      return '<i class="fal fa-sort-down cursor-pointer"></i>';
    },
    sortBy(field) {
      this.$store.commit(SET_ADMIN_TRANSACTIONS_PAGINATION_PAGE, 1);

      this.updateTransactions({
        col: field,
        dir:
          this.$store.state.adminTransactions.sort.dir === "desc"
            ? "asc"
            : "desc"
      });
    },
    updateTransactions(sort = {}) {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_TRANSACTIONS, {
          sort: sort,
          type: this.searchType,
          from: this.fromDate,
          to: this.toDate
        })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    exportTransactions() {
      this.exportloading = true;
      this.$store
        .dispatch(DOWNLOAD_ADMIN_TRANSACTIONS, {
          type: this.searchType,
          from: this.fromDate,
          to: this.toDate
        })
        .then(data => {
          this.exportloading = false;
          this.downloadFile(data.path);
        })
        .catch(() => {
          this.exportloading = false;
        });
    }
  }
};
</script>
